<template>
	<p class="text-sm text-gray-400 dark:text-gray-600"><slot/></p>
</template>
<script setup lang="ts"></script>